import React from 'react';
import { motion } from 'framer-motion';
import { Eye, Zap, Heart, Layout } from 'lucide-react';
const features = [{
  title: 'Visual',
  description: 'Está pensado para latinas',
  icon: Eye
}, {
  title: 'Simple',
  description: 'Habla tu idioma',
  icon: Zap
}, {
  title: 'Adaptado a la quincena',
  description: 'Respeta tu contexto',
  icon: Layout
}, {
  title: 'Emocionalmente sostenible',
  description: 'Entiende la quincena. Considera la parte emocional',
  icon: Heart
}];
export function Features() {
  return <section className="pt-6 pb-12 bg-gradient-to-br from-yellow/10 via-yellow/8 to-yellow/15 relative overflow-hidden" data-id="element-2">
      {/* Decorative blobs */}

      <div className="absolute bottom-10 left-10 w-64 h-64 bg-yellow/25 rounded-full blur-3xl" data-id="element-3" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-4">
        <div className="max-w-4xl mx-auto" data-id="element-5">
          {/* Book Cover Image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="relative z-10 mb-16" data-id="element-6">
            <div className="max-w-md mx-auto" data-id="element-7">
              {/* Decorative elements behind */}
              <div className="absolute -top-10 -right-10 w-32 h-32 bg-yellow rounded-full mix-blend-multiply opacity-20 blur-xl animate-pulse -z-10" data-id="element-8" />
            </div>
          </motion.div>

          {/* Why it works */}
          <div className="bg-white p-8 md:p-12 rounded-2xl shadow-xl border-l-4 border-[#1a3d3d] relative z-20" data-id="element-9">
            <h3 className="text-3xl font-bold text-slate-900 mb-8 text-center" data-id="element-10">
              ¿Por qué este sistema sí funciona?
            </h3>
            <p className="text-xl text-slate-700 mb-8 text-center" data-id="element-11">Porque:</p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-12">
              {features.map((feature, index) => <motion.div key={index} whileHover={{
              y: -5
            }} className="bg-[#f0f5ed]/70 backdrop-blur-sm p-6 rounded-xl shadow-lg border border-[#e8dcc8] hover:shadow-xl transition-all relative overflow-hidden" data-id="element-13">
                  <div className="absolute top-0 right-0 w-32 h-32 bg-yellow-400/10 rounded-full -mr-16 -mt-16 blur-2xl" data-id="element-14" />

                  <div className="w-12 h-12 bg-[#1a3d3d] rounded-lg flex items-center justify-center mb-4 shadow-lg relative overflow-hidden" style={{
                backgroundImage: `
                        repeating-linear-gradient(
                          45deg,
                          transparent,
                          transparent 10px,
                          rgba(244, 196, 48, 0.05) 10px,
                          rgba(244, 196, 48, 0.05) 20px
                        )
                      `
              }} data-id="element-15">
                    <feature.icon size={24} className="text-[#f4c430] relative z-10" data-id="element-16" />
                  </div>
                  <h3 className="text-lg font-bold text-[#1a3d3d] mb-2" data-id="element-17">
                    {feature.title}
                  </h3>
                  <p className="text-[#2d4a3a] text-sm" data-id="element-18">
                    {feature.description}
                  </p>
                </motion.div>)}
            </div>
            <div className="mt-8 text-center space-y-4" data-id="element-19">
              <p className="text-lg text-slate-700" data-id="element-20">
                No te dice "deja de gastar".{' '}
                <span className="font-bold text-[#f4c430]" data-id="element-21">
                  Te dice cómo decidir mejor.
                </span>
              </p>
              <p className="text-lg text-slate-700" data-id="element-22">
                No te quita libertad.{' '}
                <span className="font-bold text-[#f4c430]" data-id="element-23">
                  Te da estabilidad.
                </span>
              </p>
              <p className="text-xl italic text-slate-700 mt-6" data-id="element-24">
                Como las rueditas de una bicicleta. No te frenan. Te ayudan a
                avanzar sin caerte.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom decorative blob */}
      <div className="absolute -bottom-10 -left-10 w-40 h-40 bg-yellow/15 rounded-full mix-blend-multiply blur-xl" data-id="element-25" />
    </section>;
}